/* embla-kp.js — Kindpaws Embla auto-init. Mobile-first, FB/IG in-app-browser safe.
   Embla core + autoplay are self-hosted theme assets loaded in theme.liquid <head>
   (window.EmblaCarousel / window.EmblaCarouselAutoplay already present). CDN is
   only a last-resort fallback. Fallback-safe: if Embla never loads, slide 1 shows.

   Markup contract:
     <div data-embla data-embla-loop="true" data-embla-autoplay="0" data-embla-align="center">
       <div data-embla-viewport> <div data-embla-container> <div>slide</div>... </div> </div>
       <button data-embla-prev></button> <button data-embla-next></button>
       <div data-embla-dots><button data-embla-dot></button>...</div>
       <div data-embla-meta-slide>...</div>   (optional, synced to active index)
*/
(function () {
  var CDN_CORE = 'https://cdn.jsdelivr.net/npm/embla-carousel@8/embla-carousel.umd.js';
  var CDN_AUTO = 'https://cdn.jsdelivr.net/npm/embla-carousel-autoplay@8/embla-carousel-autoplay.umd.js';

  // Inject shared dot + viewport styling ONCE so auto-generated dots look consistent
  // across every [data-embla] block (kp-social-proof-cards + review/video carousels).
  function injectBaseStyles() {
    if (document.getElementById('embla-kp-base-styles')) return;
    var css =
      '[data-embla]{position:relative;}' +
      '[data-embla-viewport]{overflow:hidden;}' +
      '[data-embla-container]{display:flex;backface-visibility:hidden;touch-action:pan-y;}' +
      '[data-embla-dots]{display:flex;justify-content:center;align-items:center;gap:8px;flex-wrap:wrap;margin-top:16px;}' +
      '.embla__dot,[data-embla-dot]{appearance:none;-webkit-appearance:none;border:0;padding:0;margin:0;cursor:pointer;' +
      'width:8px;height:8px;border-radius:50%;background:rgba(10,22,40,0.22);transition:width .25s ease,background .25s ease;flex-shrink:0;}' +
      '.embla__dot.is-selected,[data-embla-dot][aria-selected="true"]{width:22px;border-radius:5px;background:#001c72;}' +
      '[data-embla-prev],[data-embla-next]{cursor:pointer;}';
    var s = document.createElement('style');
    s.id = 'embla-kp-base-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (document.querySelector('script[data-embla-cdn="' + src + '"]')) { resolve(); return; }
      var s = document.createElement('script');
      s.src = src; s.async = true; s.setAttribute('data-embla-cdn', src);
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error('embla cdn fail')); };
      document.head.appendChild(s);
    });
  }

  function ready() { return typeof window.EmblaCarousel !== 'undefined'; }

  function initOne(root) {
    if (root.__emblaInit) return;
    var viewport = root.querySelector('[data-embla-viewport]') || root.querySelector('.embla__viewport');
    if (!viewport) return;
    root.__emblaInit = true;

    var loop = root.getAttribute('data-embla-loop') !== 'false';
    var align = root.getAttribute('data-embla-align') || 'center';
    var autoplayMs = parseInt(root.getAttribute('data-embla-autoplay') || '0', 10);

    // LOOP-SEAM FIX: CSS `gap` does NOT travel with a transform-wrapped slide, so the
    // last<->first seam collides in loop mode. Convert container gap -> per-slide margin-left
    // (margins move with the transform) + a negative container offset to keep slide 1 flush.
    // Must run BEFORE EmblaCarousel() so slide sizes are measured with the margins.
    var _container = viewport.querySelector('[data-embla-container]') || viewport.firstElementChild;
    if (_container && !_container.__gapFixed) {
      var _cs = window.getComputedStyle(_container);
      var _gap = parseFloat(_cs.columnGap || _cs.gap || '0') || 0;
      if (_gap > 0) {
        _container.style.gap = '0px';
        _container.style.columnGap = '0px';
        _container.style.marginLeft = '0px';
        var _half = _gap / 2;
        var _kids = _container.children;
        for (var _i = 0; _i < _kids.length; _i++) {
          _kids[_i].style.marginLeft = _half + 'px';
          _kids[_i].style.marginRight = _half + 'px';
        }
      }
      _container.__gapFixed = true;
    }

    var plugins = [];
    if (autoplayMs > 0 && window.EmblaCarouselAutoplay) {
      plugins.push(window.EmblaCarouselAutoplay({ delay: autoplayMs, stopOnInteraction: false, stopOnMouseEnter: true }));
    }

    var embla;
    try {
      embla = window.EmblaCarousel(viewport, { loop: loop, align: align, dragFree: false, containScroll: 'trimSnaps', skipSnaps: false }, plugins);
    } catch (e) { root.__emblaInit = false; return; }

    // Auto-generate dots into an empty [data-embla-dots] container (one per snap)
    var dotsBox = root.querySelector('[data-embla-dots]');
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-embla-dot]'));
    if (dotsBox && dots.length === 0) {
      embla.scrollSnapList().forEach(function (_, i) {
        var b = document.createElement('button');
        b.setAttribute('data-embla-dot', '');
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        b.className = 'embla__dot';
        dotsBox.appendChild(b);
      });
      dots = Array.prototype.slice.call(root.querySelectorAll('[data-embla-dot]'));
    }
    var metaSlides = Array.prototype.slice.call(root.querySelectorAll('[data-embla-meta-slide]'));
    function selectDot() {
      var i = embla.selectedScrollSnap();
      dots.forEach(function (d, idx) {
        var on = idx === i;
        d.setAttribute('aria-selected', on ? 'true' : 'false');
        d.classList.toggle('is-active', on);
        d.classList.toggle('is-selected', on);
      });
      metaSlides.forEach(function (m, idx) { m.style.display = idx === i ? '' : 'none'; });
    }
    dots.forEach(function (d, idx) { d.addEventListener('click', function () { embla.scrollTo(idx); }); });
    var prev = root.querySelector('[data-embla-prev]');
    var next = root.querySelector('[data-embla-next]');
    if (prev) prev.addEventListener('click', function () { embla.scrollPrev(); });
    if (next) next.addEventListener('click', function () { embla.scrollNext(); });
    embla.on('select', selectDot);
    embla.on('reInit', selectDot);
    selectDot();
    root.__embla = embla;
    // images inside slides can change layout after load — recalc
    root.querySelectorAll('img').forEach(function (img) {
      if (!img.complete) img.addEventListener('load', function () { try { embla.reInit(); } catch (e) {} }, { once: true });
    });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-embla]');
    if (!roots.length) return;
    injectBaseStyles();
    if (ready()) { roots.forEach(initOne); return; }
    // last-resort CDN fallback (theme asset should already have loaded the global)
    loadScript(CDN_CORE)
      .then(function () { return loadScript(CDN_AUTO).catch(function () {}); })
      .then(function () { if (ready()) roots.forEach(initOne); })
      .catch(function () { /* slide 1 stays visible */ });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
